'use client'

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '@/components/ui/button'
import MeetupList from '@/features/meetups/meetup-list'

function MeetupsPage() {
  const navigate = useNavigate()
  const [activeFilter, setActiveFilter] = useState<'all' | 'hosting' | 'attending'>('all')

  const handleCreateMeetup = () => {
    navigate('/meetups/create')
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-8">
        <h1 className="text-3xl font-bold mb-4 md:mb-0">Meetups</h1>
        
        <div className="flex items-center space-x-4">
          <Button onClick={handleCreateMeetup}>
            Create Meetup
          </Button>
        </div>
      </div>
      
      <div className="mb-8">
        <div className="flex border-b border-gray-700">
          <button
            className={`px-4 py-2 font-medium ${activeFilter === 'all' ? 'text-primary border-b-2 border-primary' : 'text-gray-400'}`}
            onClick={() => setActiveFilter('all')}
          >
            All Meetups
          </button>
          <button
            className={`px-4 py-2 font-medium ${activeFilter === 'hosting' ? 'text-primary border-b-2 border-primary' : 'text-gray-400'}`}
            onClick={() => setActiveFilter('hosting')}
          >
            Hosting
          </button>
          <button
            className={`px-4 py-2 font-medium ${activeFilter === 'attending' ? 'text-primary border-b-2 border-primary' : 'text-gray-400'}`}
            onClick={() => setActiveFilter('attending')}
          >
            Attending
          </button>
        </div>
      </div>
      
      <MeetupList filter={activeFilter} />
    </div>
  )
}

export default MeetupsPage
